import { render, staticRenderFns } from "./tabEnterpriseWechat.vue?vue&type=template&id=624e1f6e&scoped=true&"
import script from "./tabEnterpriseWechat.vue?vue&type=script&lang=js&"
export * from "./tabEnterpriseWechat.vue?vue&type=script&lang=js&"
import style0 from "./tabEnterpriseWechat.vue?vue&type=style&index=0&id=624e1f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e1f6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624e1f6e')) {
      api.createRecord('624e1f6e', component.options)
    } else {
      api.reload('624e1f6e', component.options)
    }
    module.hot.accept("./tabEnterpriseWechat.vue?vue&type=template&id=624e1f6e&scoped=true&", function () {
      api.rerender('624e1f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/tabEnterpriseWechat.vue"
export default component.exports